import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next';
import { CLIENT_LEDGER_TYPE_LABELS, formatLedgerAmount } from './clientLedgerTypes';
import { localizeSystemText } from '../../i18n/messages';
import { displayDate } from '../common/datePresentation';

export default function ClientYearAssignmentReview({ preview, onSubmit, onCancel, busy }) {
  const { t, i18n } = useTranslation();
  const [rows, setRows] = useState(preview.rows.map(row => ({ ...row, schoolYearStartYear: row.schoolYearStartYear || '' })));
  const valid = rows.every(row => Number.isInteger(Number(row.schoolYearStartYear)) && Number(row.schoolYearStartYear) >= 1000 && Number(row.schoolYearStartYear) <= 9998);
  return (
    <form
      className="card p-3 mb-3"
      onSubmit={event => {
        event.preventDefault();
        if (valid && !busy) onSubmit(rows.map(row => ({ entryKey: row.entry.entryKey, schoolYearStartYear: Number(row.schoolYearStartYear) })));
      }}
    >
      <h3>{t('billing:yearScope.review')}</h3>
      <p>{t('billing:yearScope.reviewWarning')}</p>
      <div className="table-responsive">
        <table className="table">
          <thead>
            <tr>
              <th>{t('manage:date_8')}</th><th>{t('manage:type_129')}</th><th>{t('manage:amount_131')}</th>
              <th>{t('manage:month_133')}</th><th>{t('billing:yearScope.entryYear')}</th>
            </tr>
          </thead>
          <tbody>
            {rows.map((row, index) => (
              <tr key={row.entry.entryKey}>
                <td>{displayDate(row.entry.date, i18n.language)}</td><td>{localizeSystemText(CLIENT_LEDGER_TYPE_LABELS[row.entry.type] || row.entry.type, t)}</td>
                <td>{formatLedgerAmount(row.entry.amount, i18n.language)}</td><td>{row.entry.settlementMonth}</td>
                <td>
                  <input
                    aria-label={`${t('billing:yearScope.entryYear')} ${row.entry.entryKey}`}
                    className="form-control"
                    type="number"
                    min="1000"
                    max="9998"
                    required
                    value={row.schoolYearStartYear}
                    onChange={event => {
                      const { value } = event.target;
                      setRows(previous => previous.map((item, i) => (i === index ? { ...item, schoolYearStartYear: value } : item)));
                    }}
                  />
                  {row.warning && <small>{t('billing:yearScope.reviewWarning')}</small>}
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
      <p>{t('billing:yearScope.total')}: {formatLedgerAmount(rows.reduce((sum, row) => sum + Math.round(Number(row.entry.amount) * 100), 0) / 100, i18n.language)}</p>
      <div><button disabled={!valid || busy} type="submit" className="btn manage-button manage-red-button mr-2">{t('billing:yearScope.confirmReview')}</button>
        <button disabled={busy} type="button" className="btn manage-button manage-teal-button" onClick={onCancel}>{t('common:cancel')}</button>
      </div>
    </form>
  );
}
ClientYearAssignmentReview.propTypes = { preview: PropTypes.object.isRequired, onSubmit: PropTypes.func.isRequired, onCancel: PropTypes.func.isRequired, busy: PropTypes.bool };
ClientYearAssignmentReview.defaultProps = { busy: false };
